// base
import React from "react";
import { Link } from "react-router-dom";

// components
import { Button } from "..";

// assets
import arrow from "../../assets/images/transactions/arrow.png";
import "./transactionsTable.scss";
import { substring, fromNow, wei2Daon } from "../../../helper";

const TransactionsTable = ( props ) => {
  const { transactions, address } = props;

  return (
    <div className='responsive_table'>
      <table className="table_type01 transactions_table">
        <thead>
          <tr>
            <th>TX HASH</th>
            <th>BLOCK #</th>
            <th>TX TYPE</th>
            <th>FROM</th>
            <th><img src={arrow} alt="에서" /></th>
            <th>TO</th>
            <th>TIME</th>
            <th>AMOUNT</th>
            <th>GAS PRICE(Gwei)</th>
          </tr>
        </thead>
        <tbody>
          { transactions && transactions.length > 0 &&
            transactions.map((item, index) => (
              <tr key={index}>
                <td>
                  <Button color="blue" size="wide"
                          link={`/transaction/${item.hash}`} tooltip={item.hash}>
                    {substring(item.hash)}
                  </Button>
                </td>
                <td>
                  <Link to={`/blocks/detail/${item.number}`} className="link">
                    {item.number}
                  </Link>
                </td>
                <td>{item.type}</td>
                <td>
                  {
                    address === item.from &&
                    <Button color="gray" size="wide" disable={true} tooltip={item.from}>
                      {substring(item.from)}
                    </Button>
                  }
                  {
                    address !== item.from &&
                    <Button color="blue" size="wide"
                            link={`/account/${item.from}`} tooltip={item.from}>
                      {substring(item.from)}
                    </Button>
                  }
                </td>
                <td>
                  <img src={arrow} alt="에서" />
                </td>
                <td>
                  {
                    address === item.to &&
                    <Button color="gray" size="wide" disable={true} tooltip={item.to}>
                      {substring(item.to)}
                    </Button>
                  }
                  {
                    address !== item.to &&
                    <Button color="blue" size="wide"
                            link={`/account/${item.to}`} tooltip={item.to}>
                      {substring(item.to)}
                    </Button>
                  }
                </td>
                <td>{fromNow(item.time)}</td>
                <td>{wei2Daon(item.amount)}</td>
                <td>{item.price}</td>
              </tr>
            ))}
        </tbody>
      </table>
    </div>
  );
};

export default TransactionsTable;
